import type { HTMLAttributes, ReactNode } from "react";

type Tone = "info" | "warning" | "error" | "success";

interface BannerProps extends HTMLAttributes<HTMLDivElement> {
  readonly tone?: Tone;
  readonly action?: ReactNode;
}

const TONE_CLASSES: Record<Tone, string> = {
  info: "bg-info-soft text-info-fg-3 border-info-line",
  warning: "bg-caution-soft text-caution-fg-3 border-caution-line",
  error: "bg-danger-soft text-danger-fg-3 border-danger-line",
  success: "bg-success-soft text-success-fg-3 border-success-line",
};

export function Banner({ tone = "info", action, className = "", children, ...rest }: BannerProps) {
  return (
    <div
      role="status"
      className={`flex items-center justify-between gap-3 rounded-md border px-3 py-2 text-sm ${TONE_CLASSES[tone]} ${className}`}
      {...rest}
    >
      <div className="flex-1">{children}</div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
}
